// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
/**
 * A curve that has a time-dependent value (time is always between 0 and 1), and can be translated into GLSL code.
 */
class Curve {
  /**
   * @param {object} [options]
   * @param {string} [options.type]
   * @param {number} [options.timeOffset=0]
   */
 constructor(options) {
   options = options || {};

   /**
    * The value type. Should be 'float', 'vec3' or 'vec4' to indicate which getValueAt method to use.
    */
   this.type = options.type || 'float';

   /**
    * The offset of this curve, when used in a PolyCurve. Needs to be a number between 0 and 1.
    * @type {Number}
    */
   this.timeOffset = options.timeOffset || 0;
 }

 /**
  * Convert a number to GLSL code.
  * @param {number} n
  * @returns {string}
  */
 static numberToGLSL(n) {
   return (`${n}`).indexOf('.') === -1 ? `${n}.0` : `${n}`;
 }

 /**
  * Convert the curve into GLSL code.
  * @returns {string}
  */
 toGLSL() {
   return '0.0';
 }

 /**
  * Get a value at a given point in time
  * @param {number} t
  * @param {number} lerpValue
  * @returns {number}
  */
 getValueAt(t, lerpValue) {
   return 0; // To be extended by child classes
 }

 /**
  * Get a vec4 value at a given point in time
  * @param {number} t
  * @param {number} lerpValue
  * @param {Vector4} store
  */
 getVec4ValueAt(t, lerpValue, store) {}

 /**
  * @param {number} t
  * @param {number} lerpValue
  * @returns {number}
  */
 getIntegralValueAt(t, lerpValue) {
   return 0; // To be extended by child classes
 }

 /**
  * @param {number} t
  * @param {number} lerpValue
  * @param {Vector4} store
  */
 getVec4IntegralValueAt(t, lerpValue, store) {}

 /**
  * @returns {Curve}
  */
 clone() {
   // call constructor "virtually" so instance of derived class is created
   return new this.constructor(this);
 }
}

export default Curve;
